import React, { useState, useEffect } from 'react';
import { LogIn, ExternalLink, CheckCircle, Package, Mail, HeartHandshake } from 'lucide-react';
import images from '../constants/images';
import { useLocation } from 'react-router-dom';

function NewThankyouPage() {
  const [countdown, setCountdown] = useState(10);
  const [showContent, setShowContent] = useState(false);
  const location = useLocation()
  const { order_id, product_category_name, unique_id } = location.state || {};

  // memberportel redire url
  const currentDomain = window.location.hostname;

 let memberPortalUrl = "https://member.joinmensrx.com/"; // Default URL

  if (currentDomain === "https://checkout.joinmensrx.com") {
    memberPortalUrl = "https://member.joinmensrx.com/";
  } else if (currentDomain === "checkoutdev-joinmensrx.wlmd.dev") {
    memberPortalUrl = "https://mpdev-joinmensrx.wlmd.dev/";
  }

  // Fixed order ID - should be passed as a prop in production
  const orderId = location.state?.order_id;

  useEffect(() => {
    // Show content with a slight delay for animation
    setTimeout(() => setShowContent(true), 100);

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          // Redirect logic here
          // window.location.href = memberPortalUrl;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  


  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 flex items-center justify-center p-4">
      <div
        className={`max-w-3xl w-full bg-white rounded-3xl shadow-2xl p-12 relative transform transition-all duration-700 ${showContent ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
          }`}
      >

        {/* Decorative Elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden rounded-3xl pointer-events-none">
          <div className="absolute top-0 left-0 w-64 h-64 bg-blue-50 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-50"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-green-50 rounded-full translate-x-1/2 translate-y-1/2 opacity-50"></div>
        </div>

        {/* Logo */}
        <div className="flex justify-center mb-12 relative">
          <img
            src={images.logo}
            alt="Logo"
            className="h-12 transform transition-transform p-1 bg-black duration-500 hover:scale-105 thankyou_my"
          // style={{background : '#95a790'}}
          />

        </div>

        {/* Success Icon with Animation */}
        <div className="flex justify-center mb-8">
          <div className={`relative transition-all duration-700 ${showContent ? 'scale-100' : 'scale-0'
            }`}>
            <div className="absolute -inset-4 bg-green-100 rounded-full animate-pulse"></div>
            <CheckCircle className="w-24 h-24 text-green-500 relative z-10" />
          </div>
        </div>

        {/* Title and Message */}
        <div className="text-center space-y-4 mb-12 relative">
          <h1 className="text-4xl font-bold text-gray-800 mb-6 flex items-center justify-center gap-3">
            <span></span> Order Successful!<span></span>
          </h1>
          <div className="max-w-2xl mx-auto space-y-6">
            <div className="bg-blue-50 rounded-2xl p-6 inline-block">
              <div className="flex items-center justify-center gap-3 text-blue-800">
                <Package className="w-5 h-5" />
                <span className="font-mono text-lg">Order ID : {orderId}</span>
              </div>
              {/* <div className="flex items-center justify-center gap-2 text-blue-600 text-sm mt-3">
                <Mail className="w-4 h-4" />
                <span>Order confirmation sent to your email</span>
              </div> */}
            </div>
            <p className="text-gray-600 leading-relaxed px-4">
              {/* {location.state?.product_category_name === "Hair Loss" ? (
                <>
                  Thank you for your purchase! Your order has been successfully placed, and a confirmation email has been sent to you. Please login to your medical intake portal for more information. If you have any questions, feel free to reach out to our support team. We appreciate your trust and look forward to serving you again!
                </> */}
              {/* ) : " */}
              Thank you for your purchase! Your order has been successfully placed, and a confirmation email has been sent to you. Along with this email, we have also sent your member portal credentials and login details. Please log in for more information. If you have any questions, feel free to reach out to our support team. We appreciate your trust and look forward to serving you again!
              {/* "} */}
            </p>
          </div>
        </div>

        {/* Buttons with Enhanced Hover Effects */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center mb-12">
          {/* {location.state?.product_category_name === "Hair Loss" ? <button
            className="group flex items-center justify-center gap-3 px-8 py-4 bg-gray-100 text-gray-800 rounded-xl hover:bg-gray-200 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg"
            onClick={() => window.location.href = `https://herscriptsrx.com/hair-loss-onboarding/?order_id=${location.state?.order_id}&unique_id=${location.state?.unique_id}&op=intake`}
          >
            <ExternalLink className="w-5 h-5 group-hover:animate-bounce" />
            <span className="font-medium">Complete Your Medical Intake</span>
          </button> : */}
            {/* // {location.state?.product_category_name === "Weight Loss" ? <button */}
            {/* //   className="group flex items-center justify-center gap-3 px-8 py-4 bg-gray-100 text-gray-800 rounded-xl hover:bg-gray-200 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg" */}
            {/* //   onClick={() => window.location.href = `https://herscriptsrx.com/onboarding/?order_id=${location.state?.order_id}&unique_id=${location.state?.unique_id}&op=intake`} */}
            {/* // > */}
            {/* //   <ExternalLink className="w-5 h-5 group-hover:animate-bounce" /> */}
            {/* //   <span className="font-medium">Complete Your Medical Intake</span> */}
            {/* // </button> : */}
            <button
              className="group flex items-center justify-center gap-3 px-8 py-4 bg-gray-900 text-white rounded-xl hover:bg-slate-900 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg"
              onClick={() => window.location.href = memberPortalUrl}
            >
              <LogIn className="w-5 h-5 group-hover:animate-bounce" />
              <span className="font-medium">Member Portal Login</span>
            </button>
          {/* // } */}
        </div>

        {/* Enhanced Countdown with Trust Indicator */}
        {/* <div className="text-center space-y-4 relative">

          <p className="text-gray-600 font-medium">
            Redirecting in <span className="text-gray-900 font-bold">{countdown}</span> seconds...
          </p>
          <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-gray-800 to-gray-900 transition-all duration-1000 ease-linear rounded-full"
              style={{ width: `${(countdown / 10) * 100}%` }}
            />
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default NewThankyouPage;